<script>
  import Page from 'page'

  if (JSON.parse(localStorage.getItem('loginData')) !== null) {
    localStorage.clear()
    window.location.reload()
  } else {
    Page.redirect('/')
  }
</script>
